module.exports = __webpack_public_path__ + "img/jituanjianjie.12f3579c.png";